import { Component, ojs, app, payload } from "modular-openscriptjs";
import { sendEvent, authenticated, pageInfo, scrollToTop } from "../../helpers";
import AuthenticatedIndex from "./AuthenticatedIndex";
import UnAuthenticatedIndex from "./UnAuthenticatedIndex";
import { PAGES } from "../../declarations";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");


ojs(AuthenticatedIndex, UnAuthenticatedIndex);

export default class Index extends Component {

	render(auth, ...args) {
		pageInfo(PAGES.HOME);
		scrollToTop();

		if (auth.value) return this.auth(...args);
		return this.default(...args);
	}

	auth(...args) {
		return h.AuthenticatedIndex(...args);
	}

	default(...args) {
		return h.UnAuthenticatedIndex(...args);
	}
}
